import { ICreateThemeColorsParams, IFontFamily } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

import { EThemeTemplate } from '@aqx-core/common/services/company/constants';

import { DARK_THEME_COLORS, HANTEC_DARK_THEME_COLORS, HANTEC_LIGHT_THEME_COLORS, LIGHT_THEME_COLORS } from '../colors';
import { ibxSansFontFamily, poppinsFontFamily } from '../font';
import { EAppThemeScheme } from '../types';

export interface ITenantCustomThemeTemplate {
  tenantDarkThemeColors: ICreateThemeColorsParams;
  tenantLightThemeColors: ICreateThemeColorsParams;
  fontFamily: IFontFamily;
  defaultThemeScheme: EAppThemeScheme | undefined;
}

// Input ONLY the custom colors needed for the tenant

export const TENANT_CUSTOM_THEME_TEMPLATE_MAP: Record<EThemeTemplate, ITenantCustomThemeTemplate> = {
  [EThemeTemplate.HANTEC]: {
    tenantDarkThemeColors: HANTEC_DARK_THEME_COLORS,
    tenantLightThemeColors: HANTEC_LIGHT_THEME_COLORS,
    fontFamily: poppinsFontFamily,
    defaultThemeScheme: EAppThemeScheme.DARK_SCHEME
  },
  // No color customisations needed for default
  [EThemeTemplate.DEFAULT]: {
    tenantDarkThemeColors: DARK_THEME_COLORS,
    tenantLightThemeColors: LIGHT_THEME_COLORS,
    fontFamily: ibxSansFontFamily,
    defaultThemeScheme: undefined
  }
};
